/**
 * computes the SHA-1 hex digest of a string using the Web Crypto API
 * used to hash the user's email for Yoti session calls as on NEW FE
 */
export default async function sha1(text: string): Promise<string> {
  const data = new TextEncoder().encode(text)
  const hashBuffer = await crypto.subtle.digest('SHA-1', data)
  const hashArray = Array.from(new Uint8Array(hashBuffer))
  return hashArray.map(b => b.toString(16).padStart(2, '0')).join('')
}
